<template>
  <div>
    <v-container fluid>
      <v-row v-for="info in about_info" :key="info.title">
        <v-col>
          <v-lazy
            :options="{
              threshold: 0.5,
            }"
            transition="fade-transition"
          >
            <about-card
              :image="info.image"
              :image_lazy="info.image"
              :paragraphs="info.paragraphs"
              :title="info.title"
              :mobile="mobile"
            />
          </v-lazy>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import AboutCard from "../components/AboutCard.vue";
import { mapGetters } from "vuex";

export default {
  name: "AboutMe",
  components: {
    AboutCard,
  },
  computed: {
    ...mapGetters(["about_info"]),
  },
  data() {
    return {
      mobile: window.innerWidth < 800,
    };
  },
  mounted() {
    this.fetchData();
    window.addEventListener("resize", () => {
      this.mobile = window.innerWidth < 800;
    });
  },
  methods: {
    async fetchData() {
      await this.$store.dispatch("fetchAbout");
    },
  },
};
</script>
